import { render, staticRenderFns } from "./complianceResponsiblePersonList.vue?vue&type=template&id=57594bae"
import script from "./complianceResponsiblePersonList.vue?vue&type=script&lang=js"
export * from "./complianceResponsiblePersonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports